import React, { useEffect, useRef, useState, useMemo } from "react";
import Header from "../components/global/Header";
import LeftNavbar from "../components/global/LeftNavbar";
import { useTranslation } from 'react-i18next';
import { timeStamp, discriptionValidation, PROJECT_DATE_FORMAT } from "../services/Util";
import DatePickerCalendar from "../components/dashboard/calendars/DatePickerCalendar";
import $, { data, event } from "jquery";
import { useSelector } from 'react-redux'
import { getAxiosResponse, postAxiosResponse } from "../services/authApiRoutes/APImethods";
import APIUrls from "../services/APIUrls";
import Select from "react-select";
import Constants from "../Constants";
import DataTable from "react-data-table-component";
import { useNavigate } from 'react-router-dom';
import { transformBlankToNull } from "../services/Util";
import { getLoggedInUserRole } from "../services/Util";
import { Breadcrumb } from "../components/dashboard/Breadcrumb";
import ReactTooltip from "react-tooltip";
import { handleError } from "../services/authApiRoutes/APImethods";
import { RotatingLines } from "react-loader-spinner";
import { CampaignFollowers } from "../components/campaign/CampaignFollowers";
import DateFormat from "../pages/DateFormat";
import dateUtil from "../services/DateUtil";
import store from "../redux/store";

export default function CampaignEdit() {
	const scrollRef = useRef(null);
	const [sortFocus, setsortFocus] = useState('');
	const [dueDate, setDueDate] = useState("");
	const [toggle, toggleCal] = useState(false);
	const refCalendar = useRef(null);
	const refToggle = useRef(null);
	const [tagsData, setTagsData] = useState([])
	const [tagsDropdown, setTagsDropdown] = useState([]);
	let [campaign, setCampaign] = useState({ name: "" })
	const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
	const [projectNameLength, setProjectNameLength] = useState(0)
	const [projectDiscriptionLength, setProjectDiscriptionLength] = useState(0)
	const [departments, updateDepartment] = useState([]);
	const [totalRows, setTotalRows] = useState(0);
	const [perPage, setPerPage] = useState(5);
	const [currentPage, updateCurrentPage] = useState(1);
	const [checkedMembers, setCheckedMembers] = useState([])
	const [selectedCount,setSelectedCount]=useState(0)
	let [excludeUserId, setExcludeUserId] = useState([]);
	const [depId, setDepId] = useState(null)
	const [selectedMembersData, setSelectedMembersData] = useState([])
	const [tagsCheck, setTagsCheck] = useState([]);
	const [membersData, setMembersData] = useState([])
	const [membersDataCount, setMembersDataCount] = useState([])
	
	let [searchUserName, setSearchUserName] = useState(null);
	const [toggleCleared, setToggleCleared] = useState(false);
	const [pending, setPending] = useState(false);
	const [discriptionValidationFlag, setDiscriptionValidation] = useState(false)
	const navigate = useNavigate();
	const [campaignNameValidation, setCampaignNameValidation] = useState(false)
	const [modelOpenFlag, setModelFlag] = useState(true);
	const [loader, setLoader] = useState(false);
	const paginationRef = useRef();
	const [sort, setSort] = useState("");
	const [selectedOption, setSelectedOption] = useState({
		label: "All",
		value: null,
	});
	const roleArray = getLoggedInUserRole();
	const [globalOverlay, showGlobalOverlay] = useState(false);

	const [selectedRows, setSelectedRows] = useState([]);

	const customerTimeZone = store.getState()?.customer_bootstrap_data?.value?.user?.timeZone;


	useEffect(() => {
		showGlobalOverlay(true)
		//selected members should be excluded from get list 
		const id = selectedMembersData?.map(data => "&excludeUserIds=" + data?.userId)
		setExcludeUserId(id)
		//selected members should be workspace members only
		setCampaign({ ...campaign, ['workspaceMembers']: selectedMembersData })
		showGlobalOverlay(false)
	}, [selectedMembersData])

	const addMembers = async () => {
		setSelectedMembersData((prevSelectedMembers) => {
			const newMembers = [...new Set([...prevSelectedMembers, ...checkedMembers])];
			return newMembers;
		  });
		hideModel()
		//removed checked membebers list after model close
		setCheckedMembers([])
	}

	const removeFollower = async (userId) => {
		const leftMembers = selectedMembersData.filter(data => data.userId !== userId)
		// left memberts are the selected members now
		setSelectedMembersData(leftMembers)

		const selectedElement = $(document.activeElement).closest(".campaign-member-list");
		if ($(document.activeElement).closest('li').is(':last-child') &&
			selectedElement.children().length > 2) {
			selectedElement.find('li:nth-last-child(2) .remove-btn').trigger('focus');
		} else if ($(document.activeElement).closest('li').is(':last-child')) {
			$('.add-another').trigger('focus');
		}
	}


	const { t } = useTranslation();
	const translate = t;
	const showModel = () => {
		setLoader(true);
		setModelFlag(true);
		setToggleCleared(false)
		document.body.classList.add("modal-open");
		setTimeout(() => {
			$("#close-popup-btn").trigger("focus");
		}, 300);

		$(".global-dropdown-block .w-100").removeClass('hide')

		$("#add-btn").on("keydown", function (e) {
			if (e.key === Constants.TAB && !e.shiftKey) {
				e.preventDefault();
				$("#close-popup-btn").trigger("focus");
			}
		});

		$("#cancel-btn").on("keydown", function (e) {
			if (e.key === Constants.TAB && !e.shiftKey) {
				e.preventDefault();
				if ($("#add-btn").attr('disabled') === 'disabled') {
					$("#close-popup-btn").trigger("focus");
				}
				else {
					$("#add-btn").trigger("focus");
				}
			}
		});
		showGlobalOverlay(true)
		getALLAvailableMember(currentPage)
		showGlobalOverlay(false)
	};
	const hideModel = () => {
		setModelFlag(false);
		setSearchUserName(null)
		setSelectedOption({
			label: "All",
			value: null,
		})
		setDepId(null)
		//removed checked membebers list after model close
		setToggleCleared(true)
		updateCurrentPage(1)
		setCheckedMembers([])
		document.body.classList.remove("modal-open");
		$(".add-another").trigger("focus");
		$(".global-dropdown-block .w-100").addClass('hide')
	};
	const hideModalOnKeyDown = (e) => {
		if (e.key === Constants.ESCAPE) {
			hideModel()
		}
	}
	const handleKeyPress = (e) =>{
		if(e.code === "Enter"){
			toggle ? toggleCal(false) : toggleCal(true);
		}
	}
	const setBidDueDate = (event) => {
		setDueDate(event)
		setCampaign({ ...campaign, ['dueDate']: event })
		toggleCal(false)

		$('.cal-secondFocus').trigger('focus')
		$('#cal-secondFocus').removeClass('cal-secondFocus')
		$(document).mouseup(function (e) {
			var bannerCont = $('.cal-secondFocus');
			if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
				$('.cal-secondFocus').trigger('focus')
				$('#cal-secondFocus').removeClass('cal-secondFocus')
			}
		});
		refToggle.current.focus()
	}

	//owner
	const owner = useSelector(
		(loginSessionDetail) => loginSessionDetail.loginSession
	).value

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				refCalendar.current &&
				!refCalendar.current?.contains(event.target) &&
				!refToggle.current?.contains(event.target)
			) {
				toggleCal(false);
			}
		};

		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
	}, [refCalendar]);

	//date 
	const showCalendarDueDate = (e) => {
			toggle ? toggleCal(false) : toggleCal(true);
			if (toggle) {
				var requiredElement = document.querySelector(".dashCalendar");
				requiredElement?.focus();
			}
		
	};

	const noDataFoundComponent = () => {
		return (<div className="no-data-display align-center">
			<i className="nodata-icon"></i>
			<p>{Constants.NO_DATA_FOUND}</p>
		</div>);
	}
	//tags
	const availableMember = async (event) => {
		setDepId(event.value)
		setSelectedOption(event)
		setCheckedMembers([])
	}





	const theme = aaaSelected ? "dark" : "";

	useEffect(() => {
		showGlobalOverlay(true)
		workSpaceTags()
		getAllDepartment();
		//added owner to default selectd member
		setSelectedMembersData([...selectedMembersData, { userId: owner.id, firstName: owner.firstName, lastName: owner.lastName, owner: "owner", name: owner.firstName + " " + owner.lastName,role:owner?.role?.map(data=>data.displayName).join(", ") }])
		showGlobalOverlay(false)
	}, [])

	useEffect(()=>{
		getALLAvailableMember(1)
	},[searchUserName])


	useEffect(() => {
		 getALLAvailableMember(currentPage)
	}, [currentPage,depId, excludeUserId, perPage, sort])

	useEffect(() => {
		$(".lastdisable").trigger("focus");
	}, [])



	const focusfirstElement = (e) => {
		if (e.target.nextSibling === null && e.key === "ArrowDown") {
			$(".MuiList-root").find("li").first().trigger("focus");
		}

		if (e.target.prevSibling === null) {
			$(".MuiList-root").find("li").last().trigger("focus");
		}
	};

	const handleSort = async (column, sortDirection) => {

		$(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
			.attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING });

	};
	const handleTagsChange = (event) => {
		if (event.key === 'Enter') {
			event.preventDefault()
			let value = event?.target?.value.trim();
			if (!value) return;
			let finalData = tagsData.filter(data => data === value)
			if (finalData[0] !== value) {
				setTagsData([...tagsData, value]);
				let tagsDropdownData = tagsDropdown.filter(data => data.value !== value);
				setTagsDropdown(tagsDropdownData)
			}
			if (event) {
				setCampaign({ ...campaign, ['tags']: [...tagsData, value] })
			}
		} else {
			let value = event[0]?.value
			if (value) {
				setTagsData([...tagsData, value]);
				let tagsDropdownData = tagsDropdown.filter(data => data.value !== value);
				setTagsDropdown(tagsDropdownData)
				if (event) {
					setCampaign({ ...campaign, ['tags']: [...tagsData, value] })
				}
			}
		}
	};

	const clearTags = (tags) => {
		let finalTagData = tagsData.filter(data => data !== tags)
		let finalTag = tagsData.filter(data => data === tags)
		setTagsData(finalTagData)
		tagsCheck.forEach(data => {
			if (data.value === tags) {
				setTagsDropdown([...tagsDropdown, { label: finalTag[0], value: finalTag[0] }])
			}
		})
		setCampaign({ ...campaign, ['tags']: finalTagData })

		const selectedElement = $(document.activeElement).closest(".multiselect-output");
		if ($(document.activeElement).is(':last-child') &&
			selectedElement.children().length > 1) {
			selectedElement.find('button:nth-last-child(2)').trigger('focus');
		} else if ($(document.activeElement).is(':last-child')) {
			$(document.activeElement).closest(".project-information").find('.tags-dropdown input:first-of-type').trigger('focus');
		}

	}

	const clearTagsOnKeydown = (event, tags) => {
		if (event.key === Constants.ENTER) {
			clearTags(tags);
		}
	}

	const getAllDepartment = async () => {
		if (!roleArray.includes('ROLE_VENDOR')) {
			await getAxiosResponse(APIUrls.AVAILABLE_DEPARTMENT_URL)
				.then((res) => {
					if (res.data.code === 200) {
						const options = res.data.data.map(({ id, name }) => ({
							label: name,
							value: id,
						}));
						options.unshift({
							label: "All",
							value: null,
						})
						updateDepartment(options);
						setDepId(res?.data?.data[1]?.value)
					}
				})
				.catch((err) => {
					handleError(err);
				});
		}

	}
	const handleChange = ({ allSelected, selectedCount, selectedRows }) => {
		setSelectedCount(selectedCount)
		if (!modelOpenFlag) return
		if (selectedCount === 0) return
		const unselected = membersData?.filter(m => selectedRows?.findIndex(s => s.userId === m.userId) === -1);

		let data = checkedMembers?.filter(m => unselected.findIndex(s => s.userId === m.userId) === -1)

		data = [...data, ...selectedRows];

		const map = new Map();
		data.forEach(d => {
			map.set(d.userId, d);
		})
		setCheckedMembers(Array.from(map.values()));
	};

	const searchUser = (e) => {
		let name = e?.target?.value
		const regex = new RegExp(/^[A-Z a-z 0-9 ]*$/);
		if (regex.test(name)) {
			setSearchUserName(name)
			setCheckedMembers([])
			updateCurrentPage(1)
		}
	}

	const getALLAvailableMember = (pagenumber) => {
		setPending(true)
		let url = "";
		url = APIUrls.AVAILABLE_MEMBER + `excludeUserIds=${owner.id}&pageSize=${perPage}&page=${pagenumber}`
		if (excludeUserId && excludeUserId?.length > 0) {
			url = url + `${excludeUserId.join("")}`
		}
		if (depId) {
			url = url + `&department=${depId}`
		}
		if (sort !== "") {
			url = url + sort;
		}
		if (searchUserName !== null && searchUserName !== '') {
			url = url + `&name=${searchUserName}`
		}
		if(excludeUserId && excludeUserId.length > 0){
		getAxiosResponse(url).then(result => {
			
			setMembersDataCount(result?.data?.data?.result)
			if (result?.data?.data?.result && result?.data?.data?.result?.length > 0) {

				let data = result?.data?.data?.result.map(data => {
					return {
						name: data.firstName + " " + data.lastName,
						firstName: data.firstName,
						lastName: data.lastName,
						role: data?.roleSet?.roleTypes.map(data => data.displayName).join(", "),
						department: data?.userGroupMembers.map(data => (data?.userGroup?.name)).join(", "),
						data: data,
						userId: data.userId
					}
				}
				)
				setMembersData(data);
				setTotalRows(result?.data?.data?.resultCount)
				setPending(false)
				setTimeout(() => {
					if (paginationRef.current) {
						$('#' + paginationRef.current).trigger('focus');
						paginationRef.current = '';
					}
				}, 300);
		    setPending(false)
			} else {
				setMembersData([])
				setTotalRows(0)
				setPending(false)
			}
		}).catch(err=>{
			handleError(err)
		    setPending(false)
		})
	}
	}


	const rowSelectCritera = useMemo((row) => row => {
		if (checkedMembers[0]?.owner === "owner" && checkedMembers.length === 1) return false;
		return !!checkedMembers.find(m => m.userId === row.userId)
	}, [currentPage]);


	const workSpaceTags = async () => {
		if (!roleArray.includes('ROLE_VENDOR')) {
			const allTags = await getAxiosResponse(APIUrls.WORKSPACE_TAGS);
			let allTagsResult=allTags?.data?.data?.result
		    if(allTagsResult && allTagsResult.length > 0){
				const allTagsData = allTags?.data?.data?.result?.map(obj => {
					return {
						label: obj.display,
						value: obj.display
					}
				})
				setTagsDropdown(allTagsData)
				setTagsCheck(allTagsData)
			}
		}
	}

	const fieldChange = (event) => {
		if (event?.target?.name === 'name') {
			if (event?.target?.value.match(/^(?![ .]+$)[a-zA-Z .0-9.().-]*$/)) {
				setCampaign({ ...campaign, ['name']: event.target.value })
				setProjectNameLength(event.target.value)
				setCampaignNameValidation(false)
			}

		}
	}
	const setDiscription = (event) => {
		if (discriptionValidation(event?.target?.value)) {
			setDiscriptionValidation(true)
		} else {
			setCampaign({ ...campaign, ['description']: event?.target?.value })
			setProjectDiscriptionLength(event.target.value)
			setDiscriptionValidation(false)
		}
	}


	const createCampaign = (event) => {
		event.preventDefault();
		if (campaignNameValidation) { return }
		campaign = { ...campaign,  'dueDate': timeStamp(campaign.dueDate, customerTimeZone) }
		showGlobalOverlay(true)
		postAxiosResponse(APIUrls.CREATE_CAMPAIGN, transformBlankToNull(campaign))
			.then((res) => {
				if (res.data.code === 200) {
					let campaignId = res.data.data.body.id
             		showGlobalOverlay(false)
					navigate(`/campaign/${campaignId}`);
				}
				showGlobalOverlay(false)
			})
			.catch((err) => {
				handleError(err);
				showGlobalOverlay(false)

			})
	}

	//validation 
	let disableButton = true;
	if (campaign?.name === '' || campaign?.name == '0' || campaign?.name === null) {
		disableButton = true

	} else if (campaign?.dueDate == null) {
		disableButton = true
	} else if (campaignNameValidation) {
		disableButton = true
	} else if (discriptionValidationFlag) {
		disableButton = true
	}
	else {
		disableButton = false
	}

	const backToProject = () => {
		navigate(`/campaigns`)
	}
	// table column
	const columns = [
		{
			id: 'customerUser.name',
			name: 'Name',
			selector: (row) => row['name'],
			sortable: true,
		},
		{
			id: 'project.department',
			name: 'Department',
			selector: (row) => row['department'],
		},
		{
			name: 'Role',
			id: 'project.Role',
			selector: (row) => row['role'],
		},
	];


	const handlePerRowsChange = async (newPerPage, page) => {
		setPerPage(newPerPage);
		updateCurrentPage(page)
	}

	const handlePageChange = (paging) => {
		updateCurrentPage(paging);
		if ($('#pagination-last-page').attr('aria-disabled') === "true") {
			paginationRef.current = $('#pagination-previous-page').attr('id');
		} else if ($('#pagination-first-page').attr('aria-disabled') === "true") {
			paginationRef.current = $('#pagination-next-page').attr('id');
		} else {
			paginationRef.current = document.activeElement.id;
		}
	};

	$(document).on("click", ".datatable-block .rdt_TableCell button.inline-flex", function () {
		$(this).addClass('focusAdd');
	});
	$(document).on("click", ".modal-footer .btn", function () {
		$('.focusAdd').trigger('focus');
		$('.inline-flex').removeClass('focusAdd');
	});
	$(".rdt_Table").attr("aria-label", "Campaign Members");
	$(document).ready(function () {
		$(".rdt_Table .rdt_TableCol span").attr("aria-hidden", "true");
		$(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex", "-1");
	})

	const crumbs = [
		{ label: 'Campaigns', url: 'campaigns' },
		{ label: 'New Campaign', url: '' }
	];

	
	return (
		<div className="body bg-color">
			<div id="container" className="dashboard-wrapper">
				<Header ref={scrollRef} />
				<LeftNavbar />
				<section className="dashboard-content" ref={scrollRef}>
					<div id="content" className="dashboard-wrap campaign-section">
						<Breadcrumb crumbs={crumbs} />
						<div className="create-project-section create-campaign-page-outer">
							<div className="white-bg">
								<div className="create-campaign-page">
									<h3>{translate("campaign_page.start_new_campaign")}</h3>
									<form  onSubmit={createCampaign}>
										<div className="create-campaign-content flex">
											<div className="project-information create-project-information">
												<div className="flex wrap-dropdown task-form-content">
													<div className="global-dropdown-block flex-center label-blue form-group">
														<label>{translate("campaign_page.campaign_name")}</label>

														<input autoComplete="off" maxLength='50' name="name" type="text" onChange={e => fieldChange(e)} value={campaign.name} className="form-control form-control-sm" title="Campaign Name" required />
														<small>{isNaN(50 - projectNameLength?.length) ? 50 : 50 - projectNameLength?.length} characters left</small>
														{campaignNameValidation ? <small className="textDanger">Campaign name cannot start parentheses</small> : ""}
													</div>
												</div>
												<div className="flex wrap-dropdown task-form-content">
													<div className="global-dropdown-block flex-center label-blue">
														<div className="tooltip-container">

															<label>{translate("campaign_page.campaign_due_date")}</label>

															<p
																tabIndex={0} data-events={['focus']} data-eventsoff={['blur']}
																data-padding="10px 10px 10px 10px"
																data-place="right"
																data-tip={Constants.CAMPAIGN_DUE_DATE}
																data-for="campaignDueDateToolTip"
															>
																<svg
																	className="svg-tooltip-icon"
																	viewBox="0 0 1024 1024"
																	version="1.1"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
																</svg>
															</p>
															<ReactTooltip
																className="tooltip"
																id="campaignDueDateToolTip"
																delayHide={1000}
															>
																<a href="#">{translate("campaign_page.campaign_due_date")}</a><br></br>
																{Constants.CAMPAIGN_DUE_DATE}
															</ReactTooltip>
														</div>

														<div className="flex-center w-d100">
															<div className="global-dropdown-select">
																<button
																	onClick={(e) => {
																		showCalendarDueDate(e);
																	}}
																	aria-expanded={toggle ? 'true':'false'}
																	id="cal-secondFocus"
																	ref={refToggle}
																	tabIndex={0}
																	required
																	type="button" className="drop-down-btn gb-dropBtn cal-secondFocus"
																	aria-label={ dueDate !== "" ? ` Campaign due date ${dateUtil.format(dueDate,null,null)} selected` :""}
																>
																	<span>{dueDate !== "" ? dateUtil.format(dueDate,null,null) : ""}</span>
                													<span className="font-zero">{dueDate !== ""? dateUtil.format(dueDate,null,null):"Campaign due date"}</span>
																	<svg
																		aria-hidden="true"
																		className="calender-icon"
																		xmlns="http://www.w3.org/2000/svg"
																		viewBox="0 0 14 14"
																		fill="none"
																	>
																		<path
																			d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
																			fill="#3564EB"
																		/>
																	</svg>

																</button>
															</div>
															{toggle ? (
																<DatePickerCalendar
																value={dueDate?.utcTimestamp ? dueDate.utcTimestamp : dueDate}  
																className=" dueCalendar"
																minDate={new Date()} 
																selectDate={setBidDueDate} 
																/>
															) : (
																""
															)}
														</div>
													</div>
												</div>
												<div className="global-dropdown-block flex-center wrap-dropdown">
													<div className="global-dropdown-block flex-center">
														<label htmlFor="tags">{translate("campaign_page.tags")} </label>
														<div className="global-dropdown-select">
															<Select classNamePrefix='cw'
																value={tagsDropdown.filter(function (option) {
																	return option?.value === campaign?.tags;
																})}
																className='tags-dropdown'
																onChange={(event) => handleTagsChange(event)}
																closeMenuOnSelect={true}
																menuShouldScrollIntoView={false}
																isMulti
																options={tagsDropdown}
																onKeyDown={(event) => handleTagsChange(event)}
																name="Tags"
																id="tags"
																aria-label="Tags Optional"
															/>
														</div>
														<div className="multiselect-output flex">
															{tagsData &&
																tagsData.map((tags, index) => (
																	<button type='button' key={index}
																		onClick={(e) => clearTags(tags)}
																		onKeyDown={(e) => clearTagsOnKeydown(tags)}
																		aria-label={`remove ${(tags)}`}
																	>
																		<strong>{tags}</strong>
																		<svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none"
																		>
																			<path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
																		</svg>
																	</button>
																)
																)
															}
														</div>
													</div>
												</div>
												<div className="flex wrap-dropdown task-form-content">
													<div className="global-dropdown-block flex-center">
														<label htmlFor="description">{translate("campaign_page.campaign_description")} <span>Optional</span></label>
														<textarea maxLength={2500} name="description" className="textarea" onChange={e => setDiscription(e)} placeholder="2500 character limit" aria-label="Campaign Description Optional" id="description"></textarea>
														<small>{isNaN(2500 - projectDiscriptionLength?.length) ? 2500 : 2500 - projectDiscriptionLength?.length} characters left</small>
														{discriptionValidationFlag ? <span className="textDanger">Please provide valid description</span> : ""}
													</div>
												</div>
											</div>
											<div className="project-information create-project-information wd-50">
												<div className="campaign-member-heading flex">
													<div className="left">
														<div className="tooltip-container">

															<h6>{translate("campaign_page.campaign_members")}</h6>

															<p
																tabIndex={0} data-events={['focus']} data-eventsoff={['blur']}
																data-padding="10px 10px 10px 10px"
																data-place="right"
																data-tip={Constants.CAMPAIGN_MEMBER}
																data-for="campaignMemberToolTip"
															>
																<svg
																	className="svg-tooltip-icon"
																	viewBox="0 0 1024 1024"
																	version="1.1"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
																</svg>
															</p>
															<ReactTooltip
																className="tooltip"
																id="campaignMemberToolTip"
																delayHide={1000}
															>
																{Constants.CAMPAIGN_MEMBER}
															</ReactTooltip>
														</div>

														<small>{translate("campaign_page.receive_notifications")}</small>
													</div>
													 <div className="right">
														{membersDataCount && membersDataCount?.length > 0 ?
														<button type="button"
															className="add-another"
															onClick={showModel}>Add</button>:""}
													</div>
												</div>
												<div className="campaign-member-content add-role-customer scroll-640">
								                 <CampaignFollowers pending={pending} removeFollower={removeFollower} selectedMembersData={selectedMembersData} ></CampaignFollowers>
												</div>
											</div>
										</div>
										<div className="stricy-btn flex flex-center no-rightlist justify-end">
											<div className="left flex">
												<div>
													<button onClick={backToProject} type="button" className="btn-default">{translate("campaign_page.cancel")}</button>
												</div>
												<div>
													<button disabled={disableButton} className="btn ">{translate("campaign_page.create_campaign")}</button>
												</div>
											</div>
										</div>
									</form>
								</div>

							</div>
						</div>

					</div>
				</section>
			</div>
			<div id="modelPopup" className="lightbox-panel add-campaign-member" onKeyUp={(e) => hideModalOnKeyDown(e)} aria-labelledby="add-campaign" aria-modal="true" role="dialog">
				<div className="inner-lightbox-panel">
					<div className="modal-header flex">
						<strong id="add-campaign">Add Campaign Members</strong>
						<button type="button" className="close" aria-label="close" id="close-popup-btn" onClick={hideModel}>
							<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
								<path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path>
								<path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path>
							</svg>
						</button>
					</div>
					<div className="lightbox-content">
						<div className="search-deptt">
							<div className="flex wrap-dropdown task-form-content space-gap">
								<div className="global-dropdown-block form-group mr-0">
									<label htmlFor="department">Department</label>
									<Select classNamePrefix='cw'
										className="w-100 hide"
										options={departments}
										menuShouldScrollIntoView={false}
										closeMenuOnSelect={true}
										value={selectedOption}
										onChange={e => availableMember(e)}
										aria-label='department'
									/>
								</div>
								<div className="global-dropdown-block form-group">
									<label htmlFor="user name">User Name</label>
									<input autoComplete="off" type="text" className="form-control form-control-sm" name="search" value={searchUserName !== null ? searchUserName : ""} onChange={searchUser} placeholder="Search" aria-label='user name' />
								</div>
							</div>
						</div>
						<div className="search-deptt-content">
							<h6>{totalRows} User(s) Found</h6>
							<div className="table-responsive ">
								<div className="datatable-block ">
									<DataTable
										columns={columns}
										data={membersData}
										pagination
										selectableRows
										highlightOnHover
										responsive
										striped
										selectableRowsHighlight
										onSelectedRowsChange={handleChange}
										keyField="id"
										fixedHeader
										theme={theme}
										paginationServer
										paginationPerPage={5}
										paginationTotalRows={totalRows}
										onChangeRowsPerPage={handlePerRowsChange}
										paginationDefaultPage={currentPage}
										paginationRowsPerPageOptions={[5,10,15,20,50,100]}
										onChangePage={handlePageChange}
										defaultSortFieldId={1}
										clearSelectedRows={toggleCleared}
										onSort={handleSort}
										progressPending={pending}
										selectableRowSelected={rowSelectCritera}
										noDataComponent={noDataFoundComponent()}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer flex">
						<button type="button" className="btn btn-bold " onClick={hideModel} id="cancel-btn">Cancel</button>
						<button type="button" disabled={checkedMembers.length === 0} onClick={addMembers} className={checkedMembers.length > 0 ? "btn btn-bold active" : "btn btn-bold"} id="add-btn">Add</button>
					</div>
				</div>
				<div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
		</div>
			</div>
			<div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
		</div>
		</div>
	)
}
